import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoadingBar from '../../Modules/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';

import './DeadlineCases.less';


class DeadlineCases extends Component {
  getTableBody = (data) => {
    if (data.length === 0) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {this.props.noDataFoundMessage}
          </div>
        </div>
      );
    }
    if (data.empty) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {data.empty}
          </div>
        </div>
      );
    }

    const rows = data.map((item, key) => (
      <tr key={key}>
        <td>{ item.doc_no || '' }</td>
        <td>{ item.event_name || '' }</td>
        <td>{ item.date_event_filed || '' }</td>
        <td>{ item.date_due_set || '' }</td>
        <td>{ item.date_satisfied || '' }</td>
        <td>{ item.date_terminated || '' }</td>
        <td>{ item.hearing_judge || '' }</td>
      </tr>
    ));
    return (
      <div>
        <FilterTable premiumSearch={{ uuid: this.props.case_uuid, query: this.props.type }}>
          <table className="sticky-enabled tablesorter">
            <thead>
              <tr>
                <th><span>Doc.No</span></th>
                <th><span>Deadline/Hearing</span></th>
                <th><span>Event Filed</span></th>
                <th><span>Due/Set</span></th>
                <th><span>Satisfied</span></th>
                <th><span>Terminated</span></th>
                <th><span>Hearing Judge</span></th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </table>
        </FilterTable>
      </div>
    );
  };

  render() {
    const { dataReady, error, deadlines } = this.props;
    if (!dataReady) return <LoadingBar />;
    if (!_.isEmpty(error)) return <AlertError errors={error} />;
    const tableData = deadlines || [];
    const sortedTableData = tableData.empty ? tableData : _.sortBy(tableData, deadline => new Date(deadline.date_due_set)).reverse();
    return (
      <div className={this.props.type}>
        {this.getTableBody(sortedTableData)}
        <UpdateFromPacer
          pacerUpdateHandler={this.props.purchaseData}
          pacerReceipt={this.props.receipt}
          lastUpdated={this.props.lastUpdated} />
      </div>
    );
  }
};

DeadlineCases.defaultProps = {
  error: null,
  receipt: null,
  type: 'schedule',
};

DeadlineCases.propTypes = {
  case_uuid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  deadlines: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  type: PropTypes.string,
  noDataFoundMessage: PropTypes.string.isRequired,
  error: PropTypes.any,
  purchaseData: PropTypes.func.isRequired,
};

export default DeadlineCases;



// WEBPACK FOOTER //
// ./src/components/case/deadlines/DeadlineCases.js